const Api_url = 'https://bellarmin-backend.vercel.app'
// const Api_url = 'http://localhost:8080'

export { Api_url }